import { render, staticRenderFns } from "./NoteDisplay.vue?vue&type=template&id=08b00192&scoped=true&"
import script from "./NoteDisplay.vue?vue&type=script&lang=js&"
export * from "./NoteDisplay.vue?vue&type=script&lang=js&"
import style0 from "./NoteDisplay.vue?vue&type=style&index=0&id=08b00192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b00192",
  null
  
)

export default component.exports